import type { FC } from "react";
import { DetailSkeleton } from "web_myplann/Portfolio/Components/Redesign/Detail/Skeletons/DetailSkeleton";

type Props = {
	hasChart?: boolean;
};

export const DetailLoader: FC<Props> = ({ hasChart = false }) => (
	<DetailSkeleton hasChart={hasChart} />
);
